import { ReactNode } from 'react'

type Tone = 'brand' | 'accent' | 'muted' | 'inverse'

const tones: Record<Tone, string> = {
  brand: 'text-brand-700',
  accent: 'text-accent-700',
  muted: 'text-ink-tertiary',
  inverse: 'text-brand-200',
}

interface EyebrowProps {
  children: ReactNode
  tone?: Tone
  className?: string
}

export default function Eyebrow({
  children,
  tone = 'brand',
  className = '',
}: EyebrowProps) {
  return (
    <span
      className={`text-eyebrow uppercase font-semibold ${tones[tone]} ${className}`}
    >
      {children}
    </span>
  )
}
